/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IWorkFlowProtocol {
  id?: string;
  name?: string;
  description?: string | null;
  tenantId?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  tenantType?: IClinicalDictionary | null;
  encounterType?: IClinicalDictionary | null;
  protocolType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IWorkFlowProtocol> = {
  active: false,
};
